import * as actions from './actions'

// initial state
const state = {
  carwashSettings: {
    carwash_initial_benefit_charges_flag: false,
    onboarding_flag: false,
    value_amount_alert_border: 0,
    initial_benefit_value: 0
  }
}

// getters
const getters = {
  carwashSettings: (state) => {
    return state.carwashSettings
  }
}

// mutations
const mutations = {
  SET_CARWASH_SETTINGS (state, data) {
    state.carwashSettings = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
